import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useLoader } from "contexts";
import { useTranslation } from "react-i18next";

const LoaderUI = ({open = false}) => {
  const { t } = useTranslation("common");
  const { isLoader } = useLoader();
  return (
    <React.Fragment>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.tooltip + 1 })}
        open={isLoader || open}
      >
        <CircularProgress color="inherit" aria-label={t("loading")} />
      </Backdrop>
    </React.Fragment>
  );
};

export default LoaderUI;
